import type { RelaySafe } from '@vivport/backend/types';
import { relayPlatformMeta } from './relay-platform-meta';
import { formatLastSeen } from './relay-presence';

export function RelayDetails({ relay }: { relay: RelaySafe }) {
  return (
    <div className="space-y-3">
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm sm:grid-cols-4">
        <dt className="text-muted-foreground">Computer</dt>
        <dd className="font-mono text-xs">
          {relay.hostname ?? '—'}
          {relay.platform ? <span className="ml-1 font-sans text-muted-foreground">({relayPlatformMeta(relay.platform).label})</span> : null}
        </dd>
        <dt className="text-muted-foreground">Relay version</dt>
        <dd className="font-mono text-xs">{relay.relayVersion ?? '—'}</dd>
        <dt className="text-muted-foreground">Status</dt>
        <dd>{relay.status}</dd>
        <dt className="text-muted-foreground">Last seen</dt>
        <dd>{formatLastSeen(relay.lastSeenAt)}</dd>
      </dl>
      <p className="text-xs text-muted-foreground">
        Folders are chosen on that computer with the relay program; share or unshare one there and it appears or
        disappears here by itself.
      </p>
    </div>
  );
}
